import { TouchableOpacity, Text, StyleSheet } from 'react-native'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useTranslation } from 'react-i18next'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import { hapticLight } from '../../lib/haptics'

// Tasto secondario "Insight", fuori dalle card della scelta (che restano pulite): apre la scheda con le tue scelte passate
// e la forma dei corridori selezionati. Alto 44 pt, a filo sinistro, discreto (contorno) per non competere con "Salva".
export default function InsightOpener({ onPress }) {
  const { t } = useTranslation()
  const tc = useThemeColors()
  return (
    <TouchableOpacity
      onPress={() => { hapticLight(); onPress() }}
      activeOpacity={0.7}
      style={[s.btn, { borderColor: tc.rosaBorder, backgroundColor: tc.bgCard }]}
      accessibilityRole="button"
      accessibilityLabel={t('insight.open')}
    >
      <MaterialCommunityIcons name="chart-box-outline" size={18} color={tc.rosaText} />
      <Text style={[s.text, { color: tc.rosaText }]}>{t('insight.open')}</Text>
    </TouchableOpacity>
  )
}

const s = StyleSheet.create({
  btn: { alignSelf: 'flex-start', flexDirection: 'row', alignItems: 'center', gap: 8, minHeight: 44, paddingHorizontal: 16, borderRadius: 22, borderWidth: 1, marginBottom: 12 },
  text: { fontFamily: fonts.condensedBold, fontSize: 14, letterSpacing: 0.5 },
})
